import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.0_@types+node@22.12.0_db0@0.3.2_eslint@9_r7pq5ly72foroy7can5ysddhvm/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.0_@types+node@22.12.0_db0@0.3.2_eslint@9_r7pq5ly72foroy7can5ysddhvm/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/vercel/path0/wowmall-shop/middleware/auth.ts"),
  "validate-product-url-generated": () => import("/vercel/path0/wowmall-shop/middleware/validate-product-url.generated.ts"),
  "validate-product-url": () => import("/vercel/path0/wowmall-shop/middleware/validate-product-url.ts"),
  "validate-store-url": () => import("/vercel/path0/wowmall-shop/middleware/validate-store-url.ts")
}